import React, { useState, useEffect } from "react";
import axios from "axios";
//import { Link } from "react-router-dom";
//import $ from 'jquery';
import './Home.css';
import "owl.carousel/dist/assets/owl.carousel.css"; // Owl Carousel CSS
import "owl.carousel/dist/assets/owl.theme.default.css"; // Owl Carousel Theme CSS

const api_url = process.env.REACT_APP_API_URL;

const AlumniSays = () => {

    const [AlumniSays, setAlumniSays] = useState([]);

    // Fetch slider data from the API
    useEffect(() => {
        const fetchAlumniSays = async () => {
            try {
                const response = await axios.get(`${api_url}/alumni_says.php`);
                setAlumniSays(response.data);  // Save the fetched data in state
            } catch (error) {
                console.error("Error fetching sliders:", error);
            }
        };

        fetchAlumniSays();
    }, []);

    useEffect(() => {

        // Initialize Owl Carousel after the sliders data is loaded
        window.$(".testimonial-carousel").owlCarousel({
            autoplay: true,
            smartSpeed: 1000,
            center: true,
            margin: 24,
            dots: true,
            loop: true,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                }
            }
        });


    }, [AlumniSays]);  // Re-run when sliders state changes
    return (
        <>
            {/* <!-- Alumnis says Start --> */}
            {AlumniSays.length > 0 && (
                <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="text-center">
                            <h6 className="section-title bg-white text-center text-primary px-3">What our Alumni's says</h6>
                        </div>
                        <div className="owl-carousel testimonial-carousel position-relative">
                            {AlumniSays.map((ws) => (
                                <div  key={ws.id}  className="testimonial-item text-center">
                                    <img className="border rounded-circle p-2 mx-auto mb-3" src={ws.profile_img} style={{ width: '80px', height: ' 80px' }} alt={ws.fullname}/>
                                    <h5 className="mb-0">{ws.fullname}</h5>
                                    <p>{ws.profession}</p>
                                    <div className="testimonial-text bg-light text-center p-4">
                                        <p className="mb-0">{ws.message}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {/* <!--  Alumnis says  End --> */}

        </>
    );
};

export default AlumniSays;
